(function () {
  'use strict';

  var COMPANY = (window.klaviyoModulesObject && window.klaviyoModulesObject.companyId) || 'VBaX6r';
  var API = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/';
  var IMG = 'https://reviews-media.services.klaviyo.com/abc/width:260/height:260/resizing_type:fill/plain/https://klaviyo.s3.amazonaws.com/reviews/images/';
  var IMG_LG = 'https://reviews-media.services.klaviyo.com/abc/width:640/plain/https://klaviyo.s3.amazonaws.com/reviews/images/';
  var LIMIT = 10;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function starSvg() {
    return '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  }

  function stars() {
    var html = '';
    for (var i = 0; i < 5; i++) html += starSvg();
    return '<span class="moby-reviews__stars" aria-hidden="true">' + html + '</span>';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function textTail(value) {
    var text = String(value == null ? '' : value);
    if (!document.querySelector('#MainContent[data-template="product"]')) return esc(text);
    var words = text.trim().split(/\s+/);
    if (words.length < 2) return esc(text);
    var count = /^(g|ml)$/.test(words[words.length - 2]) ? 3 : 2;
    var prefix = words.slice(0, -count).join(' ');
    return (prefix ? esc(prefix) + ' ' : '') +
      '<span class="moby-text-tail">' + esc(words.slice(-count).join(' ')) + '</span>';
  }

  function formatDate(iso, lang) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString(lang === 'sv' ? 'sv-SE' : 'en-GB', {
        year: 'numeric', month: 'short', day: 'numeric'
      });
    } catch (e) {
      return '';
    }
  }

  function copy(lang) {
    if (lang === 'sv') {
      return { reviews: 'recensioner', verified: 'Verifierad köpare', more: 'Visa fler' };
    }
    return { reviews: 'reviews', verified: 'Verified buyer', more: 'Load more' };
  }

  function imgUrl(uuid, large) {
    if (!uuid) return '';
    return (large ? IMG_LG : IMG) + uuid;
  }

  function renderHistogram(hist, total) {
    if (!hist || !hist.length) return '';
    var rows = '';
    for (var star = 5; star >= 1; star--) {
      var n = hist[star - 1] || 0;
      var pct = total ? Math.round((n / total) * 100) : 0;
      rows +=
        '<div class="moby-reviews__hist-row">' +
          '<span class="moby-reviews__hist-label">' + star + ' ' + starSvg() + '</span>' +
          '<div class="moby-reviews__hist-bar"><div class="moby-reviews__hist-fill" style="width:' + pct + '%"></div></div>' +
          '<span class="moby-reviews__hist-pct">' + pct + '%</span>' +
        '</div>';
    }
    return '<div class="moby-reviews__histogram">' + rows + '</div>';
  }

  function renderPhotos(images) {
    if (!images || !images.length) return '';
    return '<div class="moby-reviews__photos">' + images.slice(0, 6).map(function (img) {
      var src = imgUrl(img.uuid);
      return src ? '<img src="' + esc(src) + '" alt="">' : '';
    }).join('') + '</div>';
  }

  function renderReview(item, lang, t) {
    var title = item.title || item.smart_quote || '';
    var photo = item.image_uuid ? imgUrl(item.image_uuid, true) : '';
    return (
      '<article class="moby-reviews__item">' +
        '<div class="moby-reviews__item-head">' +
          stars() +
          '<span class="moby-reviews__item-date">' + esc(formatDate(item.created_at, lang)) + '</span>' +
        '</div>' +
        (title ? '<h3 class="moby-reviews__item-title">' + textTail(title) + '</h3>' : '') +
        '<div class="moby-reviews__item-author">' +
          esc(item.author || '') +
          (item.verified ? ' <span class="moby-reviews__item-verified">· ' + t.verified + '</span>' : '') +
        '</div>' +
        (item.content ? '<p class="moby-reviews__item-body">' + String(item.content).split('\n').map(textTail).join('<br>') + '</p>' : '') +
        (photo ? '<div class="moby-reviews__item-photo"><img src="' + esc(photo) + '" alt=""></div>' : '') +
      '</article>'
    );
  }

  function fetchPage(productId, offset) {
    var url = API + encodeURIComponent(productId) + '/?product_id=' + encodeURIComponent(productId) +
      '&company_id=' + encodeURIComponent(COMPANY) +
      '&limit=' + LIMIT +
      '&offset=' + offset +
      '&type=reviews&media=false&kl_review_uuid=';
    return fetch(url, { credentials: 'omit' }).then(function (res) {
      if (!res.ok) throw new Error('reviews ' + res.status);
      return res.json();
    });
  }

  function mount(root, productId, lang) {
    var t = copy(lang);
    var offset = 0;
    var listEl;

    function paint(data, append) {
      var summary = data.summary || data.product || {};
      var reviews = data.reviews || [];
      var count = summary.review_count || reviews.length;
      var rating = summary.star_rating != null ? Number(summary.star_rating).toFixed(1).replace('.', ',') : '';
      var hist = summary.rating_histogram || [];

      if (!append) {
        root.innerHTML =
          '<div class="moby-reviews">' +
            '<div class="moby-reviews__score">' +
              '<div class="moby-reviews__average">' + esc(rating) + '<span class="moby-reviews__average-unit">/5</span></div>' +
              '<div class="moby-reviews__score-meta">' +
                stars() +
                '<div class="moby-reviews__count">' + count + ' ' + t.reviews + '</div>' +
              '</div>' +
            '</div>' +
            '<div class="moby-reviews__split">' +
              renderHistogram(hist, count) +
              renderPhotos(summary.review_images) +
            '</div>' +
            '<div class="moby-reviews__list"></div>' +
            '<div class="moby-reviews__more"></div>' +
          '</div>';
        listEl = root.querySelector('.moby-reviews__list');
      }

      if (!listEl) return;
      listEl.insertAdjacentHTML('beforeend', reviews.map(function (item) {
        return renderReview(item, lang, t);
      }).join(''));

      offset += reviews.length;
      var moreWrap = root.querySelector('.moby-reviews__more');
      if (!moreWrap) return;
      if (data.has_more) {
        moreWrap.innerHTML = '<button type="button" class="moby-reviews__more-btn">' + t.more + '</button>';
        moreWrap.querySelector('button').addEventListener('click', function () {
          fetchPage(productId, offset).then(function (next) { paint(next, true); });
        });
      } else {
        moreWrap.innerHTML = '';
      }
    }

    fetchPage(productId, 0).then(function (data) {
      if (!data || !(data.reviews && data.reviews.length) && !(data.summary && data.summary.review_count)) return;
      paint(data, false);
    }).catch(function () {});
  }

  function officialReady(root) {
    return !!(
      document.getElementById('klaviyo-product-reviews-wrapper') ||
      (root && (
        root.querySelector('.kl_reviews__summary') ||
        root.querySelector('.kl_reviews__histogram') ||
        root.querySelector('[class*="kl_reviews"]')
      ))
    );
  }

  function formatOfficialReviewText(root) {
    root.querySelectorAll('.kl_reviews__review__title, .kl_reviews__review__content').forEach(function (element) {
      if (element.querySelector('.moby-text-tail')) return;
      var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var node;
      var last;
      while ((node = walker.nextNode())) {
        if (node.textContent.trim() && !node.parentElement.closest('a, button')) last = node;
      }
      if (!last) return;
      var match = last.textContent.match(/^([\s\S]*?)(\S+[ \t]+\S+)(\s*)$/);
      if (!match) return;
      var span = document.createElement('span');
      span.className = 'moby-text-tail';
      span.textContent = match[2];
      var ending = last.splitText(match[1].length);
      ending.splitText(match[2].length);
      ending.replaceWith(span);
    });
  }

  ready(function () {
    var section = document.querySelector('#MainContent[data-template="product"] #customer-reviews');
    if (section) {
      formatOfficialReviewText(section);
      var observer = new MutationObserver(function () {
        observer.disconnect();
        formatOfficialReviewText(section);
        observer.observe(section, { childList: true, subtree: true });
      });
      observer.observe(section, { childList: true, subtree: true });
    }
    var empty = document.querySelector('#customer-reviews #klaviyo-reviews-all');
    if (!empty || officialReady(empty)) return;
    var productId = empty.getAttribute('data-id');
    if (!productId || productId === 'all') return;
    var lang = (empty.getAttribute('lang') || document.documentElement.lang || 'en').slice(0, 2);
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (officialReady(empty) || empty.getAttribute('data-moby-rendered') === '1') {
        window.clearInterval(timer);
        return;
      }
      if (tries >= 16) {
        window.clearInterval(timer);
        if (officialReady(empty) || empty.childElementCount) return;
        empty.setAttribute('data-moby-rendered', '1');
        mount(empty, productId, lang);
      }
    }, 150);
  });
})();
